import type { MonetaryValue as MonetaryValueType, ValueWithTrend } from '@einwert/valuation-api-client'

import { Stack, styled, useTheme } from '@mui/material'
import { ListCardInfo, MonetaryValue, TrendIcon, Typography } from 'ComponentLibrary'
import { useCurrentResolvedLocale } from 'ClientPortal/src/i18n/currentLocale'

export const GeneralInfoCell = ({ title, valueWithTrend }: { title: string; valueWithTrend?: ValueWithTrend<MonetaryValueType> }) => {
    const value = valueWithTrend ? MonetaryValue.fromMonetaryValueDataObject(valueWithTrend.value) : undefined
    const valueTrend = valueWithTrend?.trend
    const theme = useTheme()
    const locale = useCurrentResolvedLocale()
    return (
        <ListCardInfo style={{ width: '100%', padding: '0px 16px 0px 0px', gap: theme.spacing(1) }}>
            <Stack direction="row" justifyContent="space-between" width="100%">
                {title && <BlackTypography variant="headline3">{title}</BlackTypography>}
                {
                    <MarketValueTypography variant="headline3">
                        {value ? value.format({ withoutDecimals: true, locale }) : '-'}
                    </MarketValueTypography>
                }
            </Stack>
            <Stack direction="row" alignItems="center" justifyContent="flex-end" width="100%">
                {valueTrend !== undefined && <TrendIcon variant="label" trend={valueTrend} locale={locale} />}
            </Stack>
        </ListCardInfo>
    )
}

const BlackTypography = styled(Typography)(({ theme }) => ({
    color: theme.palette.customtext.black100,
}))

const MarketValueTypography = styled(Typography)(({ theme }) => ({
    minWidth: '100px',
    textAlign: 'right',
    color: theme.palette.customtext.black100,
}))
